import {Head} from "@inertiajs/react";
import {PageProps} from "@/types";
import TransactionsTable from "@/Pages/Billing/Partials/TransactionsTable";
import BillingPageLayout from "@/Pages/Billing/BillingPageLayout";

export default function UsagePage({auth, sessionFlash}: PageProps) {
    return (
        <>
            <Head title="Billing"/>
            <BillingPageLayout>

                <div className="">
                    <div className="flex flex-row justify-between items-center">
                        <h1 className="text-2xl text-gray-900 dark:text-gray-100">Usage</h1>
                    </div>
                    <div className="py-8">
                        <div className="max-w-7xl mx-auto space-y-6">

                            <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm">

                                <div className="  overflow-x-auto">

                                    <TransactionsTable/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </BillingPageLayout>
        </>
    )
}
